interface ProductImageHeightCalcProps {
	width: number
}

const ASPECT_RATIO_A2_WIDTH = 7
const ASPECT_RATIO_A2_HEIGHT = 4.89
const ASPECT_RATIO_A2 = ASPECT_RATIO_A2_WIDTH / ASPECT_RATIO_A2_HEIGHT

export const getImageFeaturedHeight = ({
	width,
}: ProductImageHeightCalcProps) => Math.trunc(width / ASPECT_RATIO_A2)
